import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlBalancete = '/service/balanceteDespesaRestService/'

class DespesasPorUnidadeService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(data) {
        return this.conex.post(urlBalancete + 'recuperarDepesaPorUnidade/', JSON.stringify(data))
    }
}

export default DespesasPorUnidadeService
